import { LogManager } from '../../../common/port/log/log.manager.port';
import { SelfSentimentReportTimeSeriesMapper } from '../../../infrastructure/mappers/sentiment/self-sentiment-report-time-series.mapper';
import { GetSelfSentimentReportTimeSeriesRequestDto } from '../../dtos/sentiment/get-self-sentiment-report-time-series.request.dto';
import { GetSelfSentimentReportTimeSeriesResponseDto } from '../../dtos/sentiment/get-self-sentiment-report-time-series.response.dto';
import { GetSelfSentimentReportTimeSeriesQuery } from '../../queries/sentiment/get-self-sentiment-report-time-series.query';

export class GetSelfSentimentReportTimeSeriesController {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly query: GetSelfSentimentReportTimeSeriesQuery,
    protected readonly mapper: SelfSentimentReportTimeSeriesMapper
  ) {}

  async get(
    props: GetSelfSentimentReportTimeSeriesRequestDto
  ): Promise<GetSelfSentimentReportTimeSeriesResponseDto> {
    try {
      const result = await this.query.execute(props);
      return result.map((res) => this.mapper.toResponse(res));
    } catch (error) {
      throw new Error(
        `GetSelfSentimentReportTimeSeriesController.get encountered an error ${error}`
      );
    }
  }
}
